import { translate } from "../localization";
import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_LEGACY_ANALYTICS_API_URL,

  responseType: "json",
});

api.interceptors.request.use(
  async (config) => {
    // An unset Axios baseURL would otherwise send requests to the local app origin.
    if (!process.env.REACT_APP_LEGACY_ANALYTICS_API_URL?.trim()) {
      throw new Error(translate("Legacy analytics requires an explicit REACT_APP_LEGACY_ANALYTICS_API_URL."));
    }
    // Check if the custom `requiresAuth` config option is true
    // console.log(config)
    if (config.requiresAuth) {

      const session = await fetchAuthSession();
      const idToken = session.tokens.idToken;
      const authToken = session.tokens.accessToken;

      const token = authToken.toString();
      // console.log(token)
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
